<nb-layout>
  <nb-sidebar fixed state='compacted'>
    <app-main-menu></app-main-menu>
  </nb-sidebar>
  <nb-layout-column>
    <div class='main-content-container'>
      <router-outlet></router-outlet>
    </div>
    <!--    <div class='app-logo'></div>-->
  </nb-layout-column>
</nb-layout>
<app-feedback></app-feedback>
